import { ApplicationFeatures, PlanLimit } from "./PlanProvider.types";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

const ProcessingActivityCountURL = "/plan/processingActivityPlanLimit";
const SystemCountUrl = "/plan/systemPlanLimit";
const PolicyCountUrl = "/plan/policyPlanLimit";
const ProcessCountUrl = "/plan/processPlanLimit";
const IncidentLogCountUrl = "/plan/incidentLogPlanLimit";
const classificationsCountUrl = "/plan/classificationPlanLimit";
const auditCountUrl = "/plan/auditPlanLimit";
const internalAuditCountUrl = "/plan/internalAssessmentPlanLimit";
const contactCountUrl = "/plan/contact";
const contractsCountUrl = "/plan/contractPlanLimit";
const frameworkCountUrl = "/plan/frameworkPlanLimit";

export function PlanProviderDataMapping() {
    const url = "/plan/";
    let oneHour = 3600000;
    const featureQuery = useDotLegalQuery<ApplicationFeatures>(url + "applicationFeatures", {
        staleTime: oneHour,
    });

    return { data: featureQuery.data, isLoading: featureQuery.isLoading };
}

//Processing Activities
export function GetProcessingActivityPlanLimit(enabled: boolean = true) {
    const { data, refetch } = useDotLegalQuery<PlanLimit>(ProcessingActivityCountURL, {
        enabled: enabled,
    });
    return { data, refetch };
}

//Systems

export function GetSystemsPlanLimit(enabled: boolean = true) {
    const { data, refetch } = useDotLegalQuery<PlanLimit>(SystemCountUrl, {
        enabled: enabled,
    });

    return { data, refetch };
}

//Policies
export function GetPolicyPlanLimit(enabled: boolean = true) {
    const { data, refetch } = useDotLegalQuery<PlanLimit>(PolicyCountUrl, {
        enabled: enabled,
    });

    return { data, refetch };
}

//Processes
export function GetProcessPlanLimit(enabled: boolean = true) {
    const { data, refetch } = useDotLegalQuery<PlanLimit>(ProcessCountUrl, {
        enabled: enabled,
    });

    return { data, refetch };
}

//Incident logs
export function GetIncidentLogPlanLimit() {
    const { data, refetch } = useDotLegalQuery<PlanLimit>(IncidentLogCountUrl);
    return { data, refetch };
}

//Classifications
export const GetLegalEntityClassificationPlanLimit = () => {
    const { isLoading, data, refetch } = useDotLegalQuery<PlanLimit>(classificationsCountUrl);

    return { classificationPlanLimitIsLoading: isLoading, classificationPlanLimitData: data, refetchClassificationPlanLimit: refetch };
};

//Audits
export const GetLegalEntityAuditPlanLimit = () => {
    const { isLoading, data, refetch } = useDotLegalQuery<PlanLimit>(auditCountUrl);

    return { legalEntityAuditPlanLimitIsLoading: isLoading, legalEntityAuditPlanLimitData: data, refetchLegalEntityAuditPlanLimit: refetch };
};

//Internal assessments
export const GetInternalAssessmentsPlanLimit = () => {
    const { isLoading, data, refetch } = useDotLegalQuery<PlanLimit>(internalAuditCountUrl);

    return { internalAssessmentPlanLimitIsLoading: isLoading, internalAssessmentPlanLimitData: data, refetchInternalAssessmentPlanLimit: refetch };
};

//Contracts
export const GetContractsPlanLimit = (enabled: boolean = true) => {
    const { isLoading, data, refetch } = useDotLegalQuery<PlanLimit>(contractsCountUrl, {
        enabled: enabled,
    });

    return { contractsPlanLimitIsLoading: isLoading, contractsPlanLimitData: data, refetchContractsPlanLimit: refetch };
};

//Frameworks
export function GetFrameworkPlanLimit(enabled: boolean = true) {
    const { data, refetch } = useDotLegalQuery<PlanLimit>(frameworkCountUrl, {
        enabled: enabled,
    });
    return { data, refetch };
}
